// extracted by mini-css-extract-plugin
export default {"wrapper":"userCardModal_wrapper__fdlsx","table":"userCardModal_table__aEZPZ"};